import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import { Query } from "./query-constant";
import { projectGqlModelFac, projectGqlModelFactory } from "../project/project.model";
import {map} from "rxjs/operators";

@Injectable()
export class HasuraGraphqlService {
  private url: string = "/api/hasuragraphql";

  constructor(public http: HttpClient) {}
  getResponseFromHasura(body: any): Promise<any> {
    return this.http.post<any>(`${this.url}/graphql`, body)
      .toPromise();
  }

  async getProjectResponseFromHasura(projectId, params: any): Promise<any> {
    const PROJECT_QUERY: any = {
      variables: {},
      query: `query project($projectId: uuid!) {
        project(where: {id: {_eq: $projectId}}) {
                ${params}
              }
            }`,
    };

    PROJECT_QUERY.variables.projectId = projectId;
    const queryParam = {
      projectId: projectId,
      query: PROJECT_QUERY,
      uiAction: "PROJECT",
    };
    return this.http.post<any>(`${this.url}/graphql`, queryParam)
      .pipe(map(projectGqlModelFac))
      .toPromise();
  }
}